<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 100 100">
    <circle cx="50" cy="50" r="50" fill="red" />
    <line x1="30" y1="30" x2="70" y2="70" stroke="white" stroke-width="10" />
    <line x1="30" y1="70" x2="70" y2="30" stroke="white" stroke-width="10" />
  </svg>
</template>
